export enum RoomCommissionType {
  RSVP = <any>'RSVP',
  RESERVATION = <any>'RESERVATION',
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/models/payment-summary/room-commission-type.ts